export const formatNumber = (nbr: number, precision?: number): string =>
  nbr.toFixed(precision).replace('.', ',')

export const convertLocaleToNumber = (value: string) =>
  Number(value.replace(',', '.'))

/**
 * Returns the number of decimal places needed to display a value
 * with the given number of significant figures.
 * e.g. (0.0018, 2) → 4, so it displays as "0.0018"
 * e.g. (1234.5, 2) → 0, so it displays as "1234"
 */
export const getEffectiveDecimals = (
  value: number,
  significantFigures: number
): number => {
  if (value === 0) return 0

  // The position of the first significant digit relative to the decimal point
  // determines how many decimal places are needed to show N significant figures
  return Math.max(
    0,
    significantFigures - 1 - Math.floor(Math.log10(Math.abs(value)))
  )
}
